import React from 'react';
import { TrophyIcon } from 'lucide-react';
export const Hero = () => {
  return <div className="w-full bg-gradient-to-b from-yellow-400 to-yellow-500 text-white" data-id="element-81">
      <div className="container mx-auto px-4 py-12 md:py-24 flex flex-col md:flex-row items-center" data-id="element-82">
        <div className="md:w-1/2 mb-10 md:mb-0 md:pr-8" data-id="element-83">
          <h1 className="text-4xl md:text-5xl font-bold mb-4" data-id="element-84">
            The History of Cristiano Ronaldo
          </h1>
          <h2 className="text-2xl md:text-3xl font-semibold mb-6" data-id="element-85">
            "The Legacy #7 Collector's Edition"
          </h2>
          <p className="text-xl mb-8" data-id="element-86">
            This Is Not Just a Book — It's a Collector's Piece
          </p>
          <p className="mb-8" data-id="element-87">
            Cristiano Ronaldo is more than a footballer. He's a living legend
            whose story has inspired millions around the globe.
          </p>
          <p className="mb-8" data-id="element-88">
            From his early nights dazzling in Lisbon, to conquering Europe in
            Madrid, Turin, and Manchester, his journey is one of greatness,
            discipline, and relentless passion.
          </p>
          <div className="flex flex-col sm:flex-row gap-4" data-id="element-89">
            <button onClick={() => {
            document.getElementById('pricing-section')?.scrollIntoView({
              behavior: 'smooth'
            });
          }} className="bg-black text-white py-3 px-8 rounded-md font-semibold hover:bg-gray-800 transition" data-id="element-90">
              Secure Your Copy
            </button>
            <button onClick={() => {
            document.querySelector('.bg-gray-900.text-white.py-16')?.scrollIntoView({
              behavior: 'smooth'
            });
          }} className="bg-white text-black py-3 px-8 rounded-md font-semibold hover:bg-gray-100 transition" data-id="element-91">
              Learn More
            </button>
          </div>
        </div>
        <div className="md:w-1/2 flex justify-center" data-id="element-92">
          <div className="relative" data-id="element-93">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/tMRubewo36Ef64CLX97MHF/r7.png" alt="The Legacy #7 Collector's Edition Book" className="rounded-lg shadow-2xl max-w-full h-auto" data-id="element-94" />
            <div className="absolute -top-4 -right-4 bg-red-600 text-white rounded-full p-3" data-id="element-95">
              <TrophyIcon className="h-6 w-6" data-id="element-96" />
            </div>
          </div>
        </div>
      </div>
    </div>;
};